import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IGrupoDTO } from 'src/app/core/dto/grupo.dto';
import { IJwtCredencialesDTO } from 'src/app/core/dto/jwt-credenciales.dto';
import { SeguridadService } from 'src/app/core/servicios/seguridad.service';
import { ModalCargandoComponent } from 'src/app/shared/componentes/modal-cargando/modal-cargando.component';
import { ModalErrorComponent } from 'src/app/shared/componentes/modal-error/modal-error.component';


@Component({
  selector: 'app-menu-perfil',
  templateUrl: './menu-perfil.component.html',
  styleUrls: ['./menu-perfil.component.css']
})
export class MenuPerfilComponent implements OnInit {

  public perfiles: IGrupoDTO[] = [];
  public titulo: string = 'Seleccione un perfil de usuario';

  constructor(
    private seguridadService: SeguridadService, 
    private router: Router, 
    private modalService: NgbModal
    ) { }

  ngOnInit(): void {
    this.getPerfilesDisponibles();
  }

  // Eventos

  onClickSetPerfilSesion(perfil:IGrupoDTO):void{
    this.setPerfilSesion(perfil);
  }
  
  // Fetch

  private getPerfilesDisponibles():void{
    this.seguridadService.getPerfilesDisponibles().subscribe(
      (res)=>{
        this.perfiles = res;

        if( this.perfiles.length == 1){
          console.log('Un perfiles');
          this.onClickSetPerfilSesion(this.perfiles[0]);
        }
      },
      (err) =>{
        //console.error(err);
      }
    );
  }

  private setPerfilSesion(perfil:IGrupoDTO):void{

    this.seguridadService.setPerfilSesion(perfil).subscribe(
      (res) => {
        //console.log(res);
        this.seguridadService.obtenerOEstablecerPerfilEnSesion();
        this.router.navigate(['/menu-certificaciones']);
      },
      (err) =>{
        //console.error(err);
        this.modalService.dismissAll();
        const refError = this.modalService.open(ModalErrorComponent, { animation: true, backdrop: 'static', keyboard: false });
        refError.componentInstance.mensaje = 'Ha ocurrido un error al establecer el perfil de sesión';
      }
    );
  }

}
